import { h } from "preact";

import IconProps from "./IconProps";

function IconSort({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg class={cssClass} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
            <g fill="#979197" fill-rule="evenodd">
                <path fill={color} d="M10.667 12c.736 0 1.333.597 1.333 1.333 0 .737-.597 1.334-1.333 1.334H5.333C4.597 14.667 4 14.07 4 13.333 4 12.597 4.597 12 5.333 12h5.334zM12 6.667c.736 0 1.333.597 1.333 1.333S12.736 9.333 12 9.333H4c-.736 0-1.333-.597-1.333-1.333S3.264 6.667 4 6.667h8zm2.667-5.334c.736 0 1.333.597 1.333 1.334C16 3.403 15.403 4 14.667 4H1.333C.597 4 0 3.403 0 2.667c0-.737.597-1.334 1.333-1.334h13.334z" transform="translate(-82 -471) translate(64 459) translate(6 6) translate(12 6)"/>
            </g>
        </svg>
    );
}

IconSort.defaultProps = {
    color: "var(--teflon)",
    width: 16,
    height: 16
};

export default IconSort;
